module.exports = __webpack_public_path__ + "img/puzzle5_b5.79937f61.png";